  export const formatPercentage = (value) => {
    return `${value >= 0 ? '+' : ''}${Number(value).toFixed(2)}%`;
  };
